module.exports = __webpack_public_path__ + "static/media/LucidaGrande.3a6b0924.woff2";